import { render, staticRenderFns } from "./CalendarioDialogo.vue?vue&type=template&id=517ff74e&scoped=true"
import script from "./CalendarioDialogo.vue?vue&type=script&lang=js"
export * from "./CalendarioDialogo.vue?vue&type=script&lang=js"
import style0 from "./CalendarioDialogo.vue?vue&type=style&index=0&id=517ff74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517ff74e",
  null
  
)

export default component.exports